export function flattenLocaleMessages(
  messages: Record<string, string | { defaultMessage: string }>,
) {
  return Object.fromEntries(
    Object.entries(messages).map(([key, val]: any) => [key, val.defaultMessage ?? val]),
  );
}
